import { WorkflowEditSidebar } from "@/pages/workflows/edit/components/WorkflowEditSidebar.tsx";
import { WorkflowEditPageStep } from "@/pages/workflows/edit/pages/workflow-edit-pages.tsx";
import { WorkflowTitleSlot } from "@/pages/workflows/edit/pages/WorkflowTitleSlot.tsx";
import { WorkflowEditAutomationConfigurationPage } from "@/pages/workflows/edit/pages/WorkflowEditAutomationConfigurationPage.tsx";
import { WorkflowEditAutomationPage } from "@/pages/workflows/edit/pages/WorkflowEditAutomationPage.tsx";
import { WorkflowEditDetailsPage } from "@/pages/workflows/edit/pages/WorkflowEditDetailsPage.tsx";
import { WorkflowEditFinalPage } from "@/pages/workflows/edit/pages/WorkflowEditFinalPage.tsx";
import { WorkflowEditFlowPage } from "@/pages/workflows/edit/pages/WorkflowEditFlowPage.tsx";
import { WorkflowEditVisibilityPage } from "@/pages/workflows/edit/pages/WorkflowEditVisibilityPage.tsx";
import { useWorkflow, useWorkflowVersion } from "@/queries/workflows/workflow.query.ts";
import { Button, FullScreenPage, Skeleton } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

export const WorkflowEditPage = () => {
  const { id, step } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: workflow } = useWorkflow(id ? parseInt(id) : undefined, !!id);
  const { data: workflowVersion, isLoading } = useWorkflowVersion(
    workflow ? { workflowId: workflow.id, workflowVersionId: workflow.current_version_id } : null,
    !!workflow
  );

  const currentStep = useMemo(() => {
    if (step) {
      return step as WorkflowEditPageStep;
    }
    return WorkflowEditPageStep.details;
  }, [step]);

  if (workflow && workflowVersion && !isLoading) {
    switch (currentStep) {
      case WorkflowEditPageStep.details:
        return <WorkflowEditDetailsPage workflow={workflow} workflowVersion={workflowVersion} />;
      case WorkflowEditPageStep.visibility:
        return <WorkflowEditVisibilityPage workflow={workflow} workflowVersion={workflowVersion} />;
      case WorkflowEditPageStep.automation:
        return <WorkflowEditAutomationPage workflow={workflow} workflowVersion={workflowVersion} />;
      case WorkflowEditPageStep.automation_setup:
        return (
          <WorkflowEditAutomationConfigurationPage
            workflow={workflow}
            workflowVersion={workflowVersion}
          />
        );
      case WorkflowEditPageStep.flow:
        return <WorkflowEditFlowPage workflow={workflow} workflowVersion={workflowVersion} />;
      case WorkflowEditPageStep.final:
        return <WorkflowEditFinalPage workflow={workflow} workflowVersion={workflowVersion} />;
    }
  }

  return (
    <FullScreenPage
      backSlot={
        <Button
          variant={"secondary"}
          size={"lg"}
          onClick={() => {
            navigate("/workflows");
          }}
        >
          {t("common:exit")}
        </Button>
      }
      titleSlot={<WorkflowTitleSlot step={WorkflowEditPageStep.details} />}
      isCenterVertical={false}
      sidebarSlot={<WorkflowEditSidebar step={WorkflowEditPageStep.details} />}
    >
      <Skeleton className={"w-full h-10"} />
    </FullScreenPage>
  );
};
